import { createAsyncThunk } from "@reduxjs/toolkit";
import { AMENITIES } from "../../../API/UserApi";
import axios from "axios";
// import apiHeader from "../../../Components/ApiHeader";

export const addUpdateSTationEmenitiesAPI: any = createAsyncThunk(
  "addUpdateStationEmenities",
  async ({ formData, method, id }: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    // const commonHead = apiHeader(token);
    try {
      const res = await axios({
        method: method,
        url: !!id ? AMENITIES + id : AMENITIES,
        data: formData,
        headers: {
          "access-control-allow-origin": "*",
          token: JSON.parse(token),
          "Content-Type": "multipart/form-data",
        },
        // headers: commonHead,
      });

      ;
      return res;
    } catch (error: any) {
      // if (error instanceof Error) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
      // }
    }
  }
);
